module.exports = __webpack_public_path__ + "static/media/powr.55aee257.svg";